export const BASE_URL = process.env.REACT_APP_API_URL;
// export const BASE_URL = 'http://localhost:5000/api/';

// AUTH
export const URL_LOGIN = `${BASE_URL}auth/login`;
export const URL_FORGOT_PASSWORD = `${BASE_URL}auth/forgot-password`;
export const GET_URL_RESET_PASSWORD = (isForcedReset) => `${BASE_URL}auth/${isForcedReset ? 'forced-reset-password' : 'reset-password'}`;
export const URL_VERIFY_MFA = `${BASE_URL}auth/mfa/verify`;

// MFA

export const URL_MFA_SETUP_ENROLL = `${BASE_URL}mfa/enroll`;
export const URL_MFA_SETUP_VALIDATE = `${BASE_URL}mfa/validate`;
export const URL_MFA_STATUS = `${BASE_URL}mfa/status`;
export const URL_MFA_DISABLE = `${BASE_URL}mfa/disable`;
export const URL_MFA_ADMIN_RESET = `${BASE_URL}mfa/admin/reset`;

// DASHBOARD
export const URL_DASHBOARD_SUMMARY = `${BASE_URL}Summary`;
export const URL_PJM_DASHBOARD_SUMMARY = `${BASE_URL}Summary/PJM`;
export const URL_PRM_DASHBOARD_SUMMARY = `${BASE_URL}Summary/PRG`;
export const URL_POM_DASHBOARD_SUMMARY = `${BASE_URL}Summary/POM`;

// ATTACHMENTS
export const URL_CREATE_ATTACHMENT = `${BASE_URL}Attachments`;
export const URL_UPDATE_ATTACHMENT = (id) => `${BASE_URL}Attachments/${id}`;
export const URL_DELETE_ATTACHMENT = (id) => `${BASE_URL}Attachments/${id}`;

// USER
export const URL_USER = `${BASE_URL}Users/`;
export const URL_USER_SELF = `${BASE_URL}Users/self`;
export const URL_USER_SELF_PERMISSIONS = `${BASE_URL}Users/self/access`;

export const URL_USERS = `${BASE_URL}Users/`;
export const URL_SORT_USERS = `${BASE_URL}Users?`;
export const URL_SEARCH_USERS = `${BASE_URL}users?searchterm=`;
export const URL_SEARCH_CLIENTS = `${BASE_URL}search/Clients?searchTerm=`;
export const URL_SEARCH_CLIENT_PROGRAM = `${BASE_URL}Clients/`;
export const URL_SEARCH_PROGRAM = `${BASE_URL}search/Programs?searchTerm=`;
export const URL_WORKING_HOURS = `WorkingHours`;
export const URL_ROLES = `${BASE_URL}Roles`;
export const URL_SEARCH_ROLE = `${BASE_URL}search/Roles?searchterm=`;
export const URL_SEARCH_ROLES = `${BASE_URL}roles?searchTerm=`;
export const URL_CREATE_ROLE = `${BASE_URL}roles`;
export const URL_UPDATE_ROLE = `${BASE_URL}Roles/`;
export const URL_DELETE_ROLE = `${BASE_URL}Roles/`;
export const URL_ROLE_FLAG = `${BASE_URL}Roles/`;
export const URL_ROLE_PERMISSIONS = `${BASE_URL}Roles/`;
export const URL_PERMISSIONS = `/permissions`;
export const URL_UPDATE_PERMISSIONS = `${BASE_URL}Roles/`;
export const URL_ALL_USERS = `${BASE_URL}users`;
export const URL_UPDATE_USER_STATUS = `${BASE_URL}Users/`;
export const URL_CREATE_USER = `${BASE_URL}users`;
export const URL_UPDATE_USER = `${BASE_URL}Users/`;
export const URL_DELETE_USER = `${BASE_URL}Users/`;
export const URL_GET_SETTINGS = `${BASE_URL}Users/self/settings`;
export const URL_LAYOUT_SETTINGS = `${BASE_URL}Users/self/layout-setting`;
export const URL_GET_NOTIFICATION_SETTINGS = `${BASE_URL}Users/self/notifications-settings`;
export const URL_UPDATE_NOTIFICATION_SETTINGS = `${BASE_URL}Users/self/notification-setting`;
export const URL_SEARCH_USER = `${BASE_URL}Search/users?searchterm=`;
export const URL_CREATE_NEW_USER = `${BASE_URL}Users/simple-create`;
export const URL_GROUPS = `${BASE_URL}Groups`;
export const URL_RESET_USER_PASSWORD = `/reset-password`;
export const URL_USER_FLAG = `${BASE_URL}Users/`;
export const URL_USER_NOTES = `${BASE_URL}Users/self/notes`;
export const URL_USER_WORKLOAD = `${BASE_URL}Users/self/workload-lookup`;
// ACCOUNT
export const URL_LOGO = `${BASE_URL}account/logo`;
export const URL_ACCOUNT = `${BASE_URL}account`;
export const URL_UPDATE_ACCOUNT = `${BASE_URL}account`;
export const URL_UPDATE_LOGO = `${BASE_URL}Account/logo`;

// NOTIFICATIONS
export const URL_NOTIFICATIONS = `${BASE_URL}Notifications`;
export const URL_DELETE_NOTIFICATION = `${BASE_URL}Notifications`;
export const URL_READ_NOTIFICATION = `${BASE_URL}Notifications/status`;
export const URL_NOTIFICATION_LINK_REDIRECTION = `${BASE_URL}Notifications/redirection/`;

// REMINDERS
export const URL_REMINDERS = `${BASE_URL}Reminders`;
export const URL_CREATE_REMINDER = `${BASE_URL}Reminders`;
export const URL_UPDATE_REMINDER = `${BASE_URL}Reminders/`;
export const URL_FETCH_REMINDER = `${BASE_URL}Reminders/`;
export const URL_DELETE_REMINDER = `${BASE_URL}Reminders`;
export const URL_READ_REMINDER = `${BASE_URL}Reminders/status`;
export const URL_SNOOZE_REMINDER = `${BASE_URL}Reminders/`;

// PROJECTS
export const URL_PROJECTS = `${BASE_URL}Projects`;
export const URL_SEARCH_PROJECTS = `${BASE_URL}projects?`;
export const URL_CREATE_PROJECT = `${BASE_URL}Projects`;
export const URL_PROJECT_FLAG = `${BASE_URL}Projects`;
export const URL_PROGRAMS = `${BASE_URL}Clients/`;
export const URL_PROJECT_DETAILS = `${BASE_URL}Projects`;

export const URL_RESOURCES = `${BASE_URL}users/`;
export const URL_UPDATE_PROJECT = `${BASE_URL}Projects`;
export const URL_DELETE_PROJECT = `${BASE_URL}Projects`;

export const URL_MILESTONES = `${BASE_URL}Milestones`;
export const URL_SCOPE = `${BASE_URL}Scopes`;
export const URL_CREATE_SCOPE = `${BASE_URL}Scopes/`;
export const URL_SCOPE_FLAG = `${BASE_URL}Scopes/`;
export const URL_UPDATE_SCOPE = `${BASE_URL}Scopes/`;
export const URL_DELETE_SCOPE = `${BASE_URL}Scopes/`;
export const URL_GET_SCOPE = `${BASE_URL}Scopes/`;
export const URL_SEARCH_SCOPE_ITEMS = `${BASE_URL}Projects/`;
export const URL_PROJECT_RESOURCES = (id) => `${BASE_URL}projects/${id}/Resources`;
export const URL_SEARCH_SCOPE = `/ChangeRequests?searchTerm=`;
export const URL_PROJECT_APPENDICES = (projectId) =>
  `${BASE_URL}projects/${projectId}/Appendices`;
export const URL_PROJECT_APPENDIX = (projectId, id) =>
  `${BASE_URL}projects/${projectId}/Appendices/${id}`;

export const URL_PROJECT_CASHFLOW = (projectId) =>
  `${BASE_URL}projects/${projectId}/Cashflow`;
export const URL_PROJECT_CASHFLOW_CREATE_LINE = (projectId) =>
  `${BASE_URL}projects/${projectId}/cashflow-lines`;
export const URL_PROJECT_CASHFLOW_UPDATE_LINE_CHECK = (projectId, lineId) =>
  `${BASE_URL}projects/${projectId}/cashflow-lines/${lineId}/update-check`;
export const URL_PROJECT_CASHFLOW_UPDATE_LINE = (projectId, lineId) => 
  `${BASE_URL}projects/${projectId}/cashflow-lines/${lineId}`;
export const URL_PROJECT_CASHFLOW_DELETE_LINE = (projectId, lineId) => 
  `${BASE_URL}projects/${projectId}/cashflow-lines/${lineId}`;
export const URL_PROJECT_CASHFLOW_CREATE_LINE_ITEM = (projectId, lineId) =>
  `${BASE_URL}projects/${projectId}/cashflow-lines/${lineId}/Items`;
export const URL_PROJECT_CASHFLOW_UPDATE_LINE_ITEM = (projectId, lineId, lineItemId) =>
  `${BASE_URL}projects/${projectId}/cashflow-lines/${lineId}/Items/${lineItemId}`;
export const URL_PROJECT_CASHFLOW_LOOKUP = (projectId) => `${BASE_URL}projects/${projectId}/Cashflow-Lookup`;
export const URL_PROJECT_FINANCIAL_KPIS = (projectId) => `${BASE_URL}projects/${projectId}/financial-kpis`;
// HEALTH STATUS
export const URL_METRIX = `/Metrics`;
export const URL_HEALTH_KPI = `/HealthKpi`;

// COMMUNICATION PLAN
export const URL_COMMUNICATION = `CommunicationPlans`;
export const URL_GET_COMMUNICATION_PLAN = `${BASE_URL}CommunicationPlans/`;
export const URL_CREATE_COMMUNICATION_PLAN = `${BASE_URL}CommunicationPlans/`;
export const URL_UPDATE_COMMUNICATION_PLAN = `${BASE_URL}CommunicationPlans/`;
export const URL_COMMUNICATION_PLAN_FLAG = `${BASE_URL}CommunicationPlans/`;
export const URL_DELETE_COMMUNICATION_PLAN = `${BASE_URL}CommunicationPlans/`;
export const URL_SEARCH_COMMUNICATION_PLAN = `CommunicationPlans?searchTerm=`;
export const URL_COMMUNICATION_PLAN_REPORT = `${BASE_URL}communicationPlans/report`;

// RESOURCE DUTY ROSTER
export const URL_RESOURCE_DUTY_ROSTER_REPORT = `${BASE_URL}resources/duty-roster/report`;

//STATUS REPORT
export const URL_STATUS_REPORT = `${BASE_URL}Projects/`;
export const URL_CREATE_PROJECT_RESOURCES = `${BASE_URL}users/`;
export const URL_UPDATE_PROJECT_RESOURCES = `${BASE_URL}Users/`;
export const URL_DELETE_PROJECT_RESOURCES = `${BASE_URL}Users/`;

// export const URL_PROJECT_USERS = `${BASE_URL}Users`;

// CLIENTS
export const URL_CLIENT = `${BASE_URL}Clients/`;
export const URL_CLIENTS = `${BASE_URL}Clients`;
export const URL_CREATE_CLIENT = `${BASE_URL}Clients`;
export const URL_UPDATE_CLIENT = `${BASE_URL}Clients/`;
export const URL_UPDATE_CLIENT_LOGO = `${BASE_URL}Clients/`;
export const URL_CLIENT_FLAG = `${BASE_URL}Clients/`;
export const URL_DELETE_CLIENT = `${BASE_URL}Clients/`;
export const URL_SEARCH_CLIENT = `${BASE_URL}Clients?searchTerm=`;
export const URL_CLIENT_DETAILS = `${BASE_URL}Clients/`;
export const URL_CLIENT_RESOURCES = (id) => `${BASE_URL}Clients/${id}/Resources`;

// CLIENT'S PORTFOLIOS
export const URL_CLIENT_PORTFOLIO = `${BASE_URL}Clients/`;
export const URL_CLIENT_PORTFOLIOS = `/Portfolios`;
export const URL_SORT_CLIENT_PORTFOLIOS = `${BASE_URL}Portfolios`;
export const URL_CREATE_CLIENT_PORTFOLIO = `${BASE_URL}portfolios`;
export const URL_UPDATE_CLIENT_PORTFOLIO = `${BASE_URL}portfolios/`;
export const URL_DELETE_CLIENT_PORTFOLIO = `${BASE_URL}Portfolios/`;
export const URL_SEARCH_CLIENT_PORTFOLIO = `${BASE_URL}search/Portfolios`;

// PROGRAMS
export const URL_PROGRAM = `${BASE_URL}Programs/`;
export const URL_CLIENT_PROGRAMS = `${BASE_URL}Programs/`;
export const URL_SORT_PROGRAMS = `${BASE_URL}Programs`;
export const URL_CREATE_PROGRAMS = `${BASE_URL}Programs`;
export const URL_UPDATE_PROGRAMS = `${BASE_URL}Programs/`;
export const URL_PROGRAM_FLAG = `${BASE_URL}Programs/`;
export const URL_DELETE_PROGRAMS = `${BASE_URL}Programs/`;
export const URL_PROGRAM_DETAILS = `${BASE_URL}Programs/`;
export const URL_SEARCH_PROGRAMS = `${BASE_URL}Clients?searchTerm=`;
export const URL_PROGRAM_RESOURCES = (id) => `${BASE_URL}Programs/${id}/Resources`;
export const URL_PROGRAM_PROGRESS_TRACKER = (id) => `${BASE_URL}Programs/${id}/ProgressTracker`;

//SCOPES
export const URL_SCOPES = `${BASE_URL}Projects/`;

//TASKS
export const URL_TASK = `${BASE_URL}Scopes/`;
export const URL_TASKS = `${BASE_URL}Tasks`;
export const URL_CREATE_TASK = `${BASE_URL}Tasks/`;
export const URL_GET_TASK_DETAILS = `${BASE_URL}Tasks/`;
export const URL_UPDATE_TASK = `${BASE_URL}Tasks/`;
export const URL_TASK_FLAG = `${BASE_URL}Tasks/`;
export const URL_DELETE_TASK = `${BASE_URL}Tasks/`;
export const URL_SEARCH_TASK = `/Tasks?searchTerm=`;
export const URL_RESOURCES_MONITOR = `${BASE_URL}Resources/Monitor`;

//TASK GROUPS
export const URL_TASKGROUPS = `${BASE_URL}taskgroups`;
export const URL_RESOURCE_SHIFT = `${BASE_URL}Tasks/preview-assignments`;

//BUDGETS
export const URL_BUDGETS = `${BASE_URL}CostItems/`;
export const URL_PROJECT_BUDGETS = `${BASE_URL}Projects/`;
export const URL_PROGRAM_BUDGETS = `${BASE_URL}Programs/`;
export const URL_BUDGET = `${BASE_URL}CostItems/`;
export const URL_CREATE_BUDGET = `${BASE_URL}CostItems`;
export const URL_UPDATE_BUDGET = `${BASE_URL}CostItems/`;
export const URL_BUDGET_FLAG = `${BASE_URL}CostItems/`;
export const URL_DELETE_BUDGET = `${BASE_URL}CostItems/`;
export const URL_SEARCH_BUDGET = `/CostItems?searchTerm=`;
export const URL_SEARCH_BUDGET_ONLY = `/Budgets?searchTerm=`;

//CHANGE REQUESTS
export const URL_SEARCH_REQUEST = `${BASE_URL}ChangeRequests?searchTerm=`;
export const URL_CHANGE_REQUEST = `${BASE_URL}ChangeRequests/`;
export const URL_CREATE_CHANGE_REQUEST = `${BASE_URL}ChangeRequests`;
export const URL_UPDATE_CHANGE_REQUEST = `${BASE_URL}ChangeRequests/`;
export const URL_CHANGE_REQUEST_FLAG = `${BASE_URL}ChangeRequests/`;
export const URL_DELETE_CHANGE_REQUEST = `${BASE_URL}ChangeRequests/`;
export const URL_SEARCH_CHANGE_REQUEST = `/ChangeRequests?searchTerm=`;
export const URL_CREATE_CHANGE_REQUEST_RISK = `${BASE_URL}Risks`;

//MEETINGS
export const URL_MEETINGS = `${BASE_URL}Meetings?`;
export const URL_FETCH_MEETING = (id) => `${BASE_URL}Meetings/${id}`;
export const URL_FETCH_MEETING_OCCURRENCE = (id) => `${BASE_URL}Meetings/Occurrences/${id}`;
export const URL_CREATE_MEETING = `${BASE_URL}Meetings`;
export const URL_CREATE_MEETING_OCCURRENCE = (parentMeetingId, inherit = true) => `${BASE_URL}Meetings/${parentMeetingId}/Occurrences${inherit ? '/inherit':''}`;
export const URL_UPDATE_MEETING = (id) => `${BASE_URL}Meetings/${id}`;
export const URL_UPDATE_MEETING_DATES = (id) => `${BASE_URL}Meetings/${id}/Dates`;
export const URL_UPDATE_MEETING_OCCURRENCE = (id) => `${BASE_URL}Meetings/Occurrences/${id}`;
export const URL_UPDATE_MEETING_OCCURRENCE_DATES = (id) => `${BASE_URL}Meetings/Occurrences/${id}/Dates`;
export const URL_CANCEL_MEETING = (id) => `${BASE_URL}Meetings/${id}/Cancel`;
export const URL_CANCEL_MEETING_OCCURRENCE = (id, editType) => `${BASE_URL}Meetings/Occurrences/${id}/Cancel?editType=${editType}`;
export const URL_DELETE_MEETING = (id) => `${BASE_URL}Meetings/${id}`;
export const URL_DELETE_MEETING_OCCURRENCE = (id, editType) => `${BASE_URL}Meetings/Occurrences/${id}?editType=${editType}`;

export const URL_MEETING_REGISTERY = `${BASE_URL}Meetings/registry?`;
export const URL_SEARCH_MEETING_REGISTERY = `${BASE_URL}Meetings/registry?`;
export const URL_MEETING_REGISTERY_PDF = (id) => `${BASE_URL}Meetings/${id}/report`;
export const URL_MEETING_OCCURRENCE_REGISTERY_PDF = (id) => `${BASE_URL}Meetings/Occurrences/${id}/report`;


export const URL_RISK = `${BASE_URL}Risks/`;
export const URL_GET_RISK_DETAILS = `${BASE_URL}Risks/`;
export const URL_CREATE_RISK = `${BASE_URL}Risks/`;
export const URL_UPDATE_RISK = `${BASE_URL}Risks/`;
export const URL_RISK_FLAG = `${BASE_URL}Risks/`;
export const URL_DELETE_RISK = `${BASE_URL}Risks/`;
export const URL_SEARCH_RISK = `Risks?searchTerm=`;
export const URL_GET_SEARCH_CHANGE_REQUEST = `${BASE_URL}search/ChangeRequests?searchterm=`;

// Portfolio
export const URL_PORTFOLIO = `${BASE_URL}Portfolios`;
export const URL_PORTFOLIO_DETAILS = `${BASE_URL}Clients`;
export const URL_CREATE_PORTFOLIO = `${BASE_URL}portfolios`;
export const URL_UPDATE_PORTFOLIO = `${BASE_URL}Portfolios`;
export const URL_PORTFOLIO_FLAG = `${BASE_URL}Portfolios`;
export const URL_DELETE_PORTFOLIO = `${BASE_URL}Portfolios/`;
export const URL_SEARCH_PORTFOLIO = `${BASE_URL}portfolios?searchTerm=`;
export const URL_PORTFOLIO_RESOURCES = (id) => `${BASE_URL}portfolios/${id}/Resources`;

// Shifts
export const URL_SHIFTS = `${BASE_URL}Shifts`;
export const URL_SHIFT_DETAILS = `${BASE_URL}Shifts/`;
export const URL_CREATE_SHIFT = `${BASE_URL}Shifts`;
export const URL_UPDATE_SHIFT = `${BASE_URL}Shifts/`;
export const URL_SHIFT_FLAG = `${BASE_URL}Shifts/`;
export const URL_DELETE_SHIFT = `${BASE_URL}Shifts/`;
export const URL_ASSIGN_SHIFT = `${BASE_URL}Resources/assign-shifts`;
export const URL_SEARCH_SHIFT = `${BASE_URL}Shifts?searchTerm=`;

//Tenant

export const URL_DEMO_REQUEST = `${BASE_URL}Account/demo-request`;

// Contacts
export const URL_CONTACTS = `${BASE_URL}Contacts/`;
export const URL_SEARCH_CONTACTS = (parentType, parentId) =>
  `${BASE_URL}search/${parentType}/${parentId}/contacts?searchTerm=`;
export const URL_LIST_CONTACTS = (parentType, parentId) =>
  `${BASE_URL}${parentType}/${parentId}/contacts`;
export const URL_CREATE_CONTACT = (parentType, parentId) =>
  `${BASE_URL}${parentType}/${parentId}/contacts`;
export const URL_UPDATE_CONTACT = (parentType, parentId, contactId) =>
  `${BASE_URL}${parentType}/${parentId}/contacts/${contactId}`;

// Panel data source: own + shared ancestors + descendant rollup
export const URL_VIEW_CONTACTS = (parentType, parentId) =>
  `${BASE_URL}${parentType}/${parentId}/contacts/view`;
export const URL_DELETE_CONTACT = (parentType, parentId, contactId, hardDelete = false) =>
  `${BASE_URL}${parentType}/${parentId}/contacts/${contactId}?hardDelete=${hardDelete}`;

// DeleteRequests
export const URL_DELETION_REQUESTS = `${BASE_URL}DeletionRequests/`;
export const URL_CREATE_DELETION_REQUESTS = URL_DELETION_REQUESTS;
export const URL_CONFIRM_DELETION_REQUEST = (id) =>
  `${URL_DELETION_REQUESTS}${id}/Confirm`;
export const URL_CANCEL_DELETION_REQUESTS = `${URL_DELETION_REQUESTS}Cancel`;
export const URL_RESEND_DELETION_REQUESTS_EMAIL = `${URL_DELETION_REQUESTS}Resend`;

//PURCHASE_ORDERS
export const URL_PURCHASE_ORDERS = `${BASE_URL}PurchaseOrders/`;
export const URL_PROJECT_PURCHASE_ORDERS = (projectId) =>
  `${BASE_URL}Projects/${projectId}/PurchaseOrders`;
export const URL_SEARCH_PURCHASE_ORDER = `/PurchaseOrders?searchTerm=`;

//INVOICE_REGISTRY
export const URL_INVOICE_REGISTRY = `${BASE_URL}InvoiceRegistry/`;
export const URL_PROJECT_INVOICE_REGISTRY = (projectId) =>
  `${BASE_URL}Projects/${projectId}/InvoiceRegistry`;

//DECISION_LOG
export const URL_DECISION_LOG = `${BASE_URL}DecisionLog/`;
export const URL_PROJECT_DECISION_LOG = (projectId) =>
  `${BASE_URL}Projects/${projectId}/decisionLog`;
export const URL_PROGRAM_DECISION_LOG = (programId) =>
  `${BASE_URL}Programs/${programId}/decisionLog`;
export const URL_SEARCH_INVOICE_REGISTRY = `/InvoiceRegistry?searchTerm=`;
export const URL_SEARCH_PROJECT_PURCHASE_ORDERS = (projectId) =>
  `${BASE_URL}search/PurchaseOrders?ProjectId=${projectId}&searchTerm=`;

//EXPORT
export const URL_EXPORT = `${BASE_URL}Export`;

// RUNBOOKS
export const URL_RUNBOOKS = `${BASE_URL}runbooks`;
export const URL_RUNBOOK = (id) => `${BASE_URL}runbooks/${id}`;
export const URL_RUNBOOK_START = (id) => `${BASE_URL}runbooks/${id}/start`;
export const URL_RUNBOOK_STOP = (id) => `${BASE_URL}runbooks/${id}/stop`;
export const URL_RUNBOOK_ACTIONS = (runbookId) => `${BASE_URL}runbooks/${runbookId}/actions`;
export const URL_RUNBOOK_ACTION = (runbookId, actionId) => `${BASE_URL}runbooks/${runbookId}/actions/${actionId}`;
export const URL_RUNBOOK_ACTION_COMPLETE = (runbookId, actionId) => `${BASE_URL}runbooks/${runbookId}/actions/${actionId}/complete`;
export const URL_RUNBOOK_DUPLICATE = (id) => `${BASE_URL}runbooks/${id}/duplicate`;
export const URL_RUNBOOK_ACTION_DUPLICATE = (runbookId, actionId) => `${BASE_URL}runbooks/${runbookId}/actions/${actionId}/duplicate`;
export const URL_RUNBOOK_ACTION_REORDER = (runbookId, actionId) => `${BASE_URL}runbooks/${runbookId}/actions/${actionId}/reorder`;
